import React from "react";
import PropTypes from "prop-types";
import MuiIconButton from "@mui/material/IconButton";

import Icon from "../Icon/Icon";

const IconButton = ({
  iconName,
  ariaLabel,
  className,
  disabled = false,
  onClick,
  type = "button",
  fontSize = "small",
  ...rest
}) => (
  <MuiIconButton
    type={type}
    className={className}
    disabled={disabled}
    onClick={onClick}
    aria-label={ariaLabel}
    size="small"
    {...rest}
  >
    <Icon name={iconName} fontSize={fontSize} />
  </MuiIconButton>
);

IconButton.propTypes = {
  iconName: PropTypes.string.isRequired,
  ariaLabel: PropTypes.string.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  type: PropTypes.oneOf(["button", "submit", "reset"]),
  fontSize: PropTypes.oneOf(["inherit", "small", "medium", "large"]),
};

export default IconButton;
